import { CREATE_ORDER_SUCCEEDED, GET_ORDERS_LIST_SUCCEEDED, CONTACT_PAGE_SUCCEEDED, GET_ORDER_DETAILS_SUCCEEDED } from "../actions/types";


const initalState = {
    orderId: {},
    ordersList: [],
    orderDetails: {},
    contactMessage: ""
}

export default function(state = initalState, action){
    switch(action.type) {
        case CREATE_ORDER_SUCCEEDED:
            return {
                ...state,
                orderId: action.payload
            }
        case GET_ORDERS_LIST_SUCCEEDED:
            return {
                ...state,
                ordersList: action.payload
            }
        case CONTACT_PAGE_SUCCEEDED:
            return {
                ...state,
                contactMessage: action.payload
            }
        case GET_ORDER_DETAILS_SUCCEEDED:
            return {
                ...state,
                orderDetails: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/payment.reducer.js